/**
 * Loose RFC-5321-ish email validation shared by the signup form
 * (client) and the auth/mailer paths (server). We only need to filter
 * out obviously bad strings — SES rejects anything truly malformed,
 * and a full RFC parser would be overkill for the signup hot path.
 */
export function isValidEmail(value) {
    if (!value || value.length > 254)
        return false;
    const at = value.indexOf('@');
    if (at <= 0 || at !== value.lastIndexOf('@'))
        return false;
    if (at === value.length - 1)
        return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
}
/**
 * Canonical form used for uniqueness checks and suppression-list keys:
 * trimmed + lower-cased. Gmail-style dot/plus folding is deliberately
 * NOT applied — we treat what the user typed as the address.
 */
export function normalizeEmail(value) {
    return value.trim().toLowerCase();
}
//# sourceMappingURL=email.js.map